export default __webpack_public_path__ + "static/6-d7b524ee36b024d04a204aa6a5a1d55b.png";